import React, { useContext, useEffect, useState } from "react"; // eslint-disable-line no-unused-vars
import {
  Grid,
  TextField,
  IconButton,
  Typography,
  Hidden,
  Link,
  Button,
} from "@material-ui/core";
import {
  Add as AddIcon,
  Remove as RemoveIcon,
  Info as InfoIcon,
} from "@material-ui/icons";
import * as consts from "../../consts";

export default function CardQuantity(props) {
  const [quantity, setQuantity] = useState(props.cardDetails.length);
  const [showLargeOrderInfo, setShowLargeOrderInfo] = useState(false);

  useEffect(() => {
    setQuantity(props.cardDetails.length);
  }, [props.cardDetails]);

  return (
    <Grid
      container
      item
      xs={12}
      spacing={2}
      className={props.classes.cardquantitymain}
    >
      <Grid item xs={12}>
        <Typography
          variant="h5"
          color="primary"
          className={props.classes.cardquantitytitle}
        >
          Card Quantity
        </Typography>
        <Hidden xsDown={true}>
          <Button
            variant="outlined"
            color="secondary"
            className={props.classes.bulkentrytoggle}
            onClick={() => {
              props.openBulkEntry();
            }}
          >
            Upload Large Orders
          </Button>
        </Hidden>
      </Grid>
      <Hidden mdUp={true}>
        <Typography
          variant="body1"
          className={props.classes.bulkoptiontextinfo}
        >
          Large Orders
          <IconButton
            className={props.classes.bulkoptioniconButton}
            size="small"
            aria-label="Large Orders"
            color="inherit"
            onClick={(event) => {
              setShowLargeOrderInfo(!showLargeOrderInfo);
            }}
          >
            <InfoIcon fontSize="small" />
          </IconButton>
          {showLargeOrderInfo && (
            <Grid item xs={12}>
              <Typography variant="body1">
                For large orders check out our spreadsheet upload option on a
                laptop or desktop computer, or email us at info@tisbest.org.
              </Typography>
            </Grid>
          )}
        </Typography>
      </Hidden>
      <Grid item xs={12} className={props.classes.cardquantityinputs}>
        <IconButton
          className={props.classes.cardquantitybutton}
          aria-label="Remove one gift card"
          onClick={() => {
            props.onCardQuantityChanged(props.cardDetails.length - 1);
          }}
        >
          <RemoveIcon fontSize="large" />
        </IconButton>
        <TextField
          inputProps={{
            name: "quantity",
            autoComplete: "off",
          }}
          className={props.classes.cardquantityinput}
          type="number"
          required={true}
          min={consts.MIN_CARD_QUANTITY}
          // max={consts.MAX_CARD_QUANTITY}
          variant="outlined"
          value={quantity}
          onChange={(event) => {
            setQuantity(event.target.value);
          }}
          onBlur={(event) => {
            props.onCardQuantityChanged(parseInt(event.target.value));
          }}
        />
        <IconButton
          className={props.classes.cardquantitybutton}
          aria-label="Add one gift card"
          onClick={() => {
            props.onCardQuantityChanged(props.cardDetails.length + 1);
          }}
        >
          <AddIcon fontSize="large" />
        </IconButton>
      </Grid>
    </Grid>
  );
}
